import { useContext, useState, useEffect } from "react";
import { AppContext } from "context/AppContext";
import styled from "styled-components";
import { Colors, Spacing } from "@paclife/plds.tokens";
import { useTranslation } from "react-i18next";

import AuthenticatorModal from "components/AuthenticatorModal/AuthenticatorModal";
import DeleteModal from "components/DeleteModal/DeleteModal";
import Typography from "common/Typography/Typography";
import OverflowMenu from "common/OverflowMenu/OverflowMenu";
import MFAStatus from "components/MFAStatus/MFAStatus";


const Wrapper = styled.div`
    display: flex;
    margin-bottom: ${Spacing[32]};
`;

const Label = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${Spacing[8]};
`;

const Text = styled(Typography)`
    display: block;
    color: ${({ color }) => color};
    &.label-text {
        margin-right: ${Spacing[4]};
    }
`;


const GoogleAuth = ({ type }) => {    
    const { t } = useTranslation("loginSecurity");
    const {
        personal,
        account: { authenticator,factors }
    } = useContext(AppContext);

    const factorType = type.toLowerCase();
   	const [status, setStatus] = useState(false);
    const activeFactor = status === "ACTIVE";	
    const [deleteModal, setDeleteModal] = useState(false);
    const [authenticatorModal, setAuthenticatorModal] = useState(false);

    const openAuthenticatorModal = () => {        
        setAuthenticatorModal(true);
    };

    const closeModal = () => {
        setAuthenticatorModal(false);
    };

    const openDeleteModal = () => {
        setDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setDeleteModal(false);
    };

    const add_menu = [{
        icon: "add",
        color: Colors.neutral1000,
        action: "Add",
        onClick: openAuthenticatorModal
    }];

    const active_menu = [{
        icon: "delete",
        color: Colors.neutral1000,
        action: "Delete",
        onClick: openDeleteModal
    }];
		
	useEffect(() => {
		 if (factors !== undefined) {
           getGoogleAuthStatus(factors,factorType);
        } 
	}, [factors,factorType]);	
	
 	const getGoogleAuthStatus = (data,factorTypeFromGlobal) => {
        let sts = "";           
        if (data.length > 0) {
            data.forEach(({ factorType, status }) => {  	           
                if (factorType === factorTypeFromGlobal) { 
                    sts = status;
                    return;
                } 
            });
            setStatus(sts);
        }
    }
    return (
        <>
            <Wrapper>
                <OverflowMenu
                    color={Colors.blue600}
                    icon={activeFactor ? "overflowMenuVertical" : "add"}
                    onClick={ openAuthenticatorModal }
                    menu={activeFactor ? active_menu : add_menu}
                />
                <div>
                    <Label>
                        <Text
                            className="label-text"
                            variant="caption"
                            display="block"
                            color={Colors.textBodyLight}
                            bold
                        >
                            {t("authenticator.type")}
                        </Text>
                    </Label>
                    {t("authenticator.desc")}
                    <MFAStatus status={status} />
                </div>
            </Wrapper>
            {(authenticatorModal) && (
                <AuthenticatorModal
                    closeModal={ closeModal }
                    factorType="token:software:totp"
                    subType=""
                    defaultValue={authenticator}
                    defaultScreen={"update"}
                />
            )}
            {(deleteModal) && (
                <DeleteModal
                    closeModal={ closeDeleteModal }
                    factorType="token:software:totp"
                    subType="google"
                    defaultValue={personal.username}
                />
            )}
        </>
    );

}

export default GoogleAuth;